// Generated by tools/fetchGameData.mjs from fftbattleground.com/fftbg/legacyitem.txt: old item
// name → its current name. Do not edit by hand; re-run the tool.
export const LEGACY_ITEM_NAMES = {
  "Adaman Vest": "Adamant Vest",
  "Ama no Murakumo": "Heaven's Cloud",
  "Ama-no-Murakumo": "Heaven's Cloud",
  "Artemis Bow": "Ultimus Bow",
  "Ashura": "Asura Knife",
  "Assassin's Dagger": "Assassin Dagger",
  "Assassins Dragger": "Assassin Dagger",
  "Barbut": "Barbuta",
  "Battle Dict": "Battle Folio",
  "Black Cowl": "Black Hood",
  "Black Garb": "Black Costume",
  "Blaster": "Blast Gun",
  "Bloodstring Harp": "Bloody Strings",
  "Bowgun": "Bow Gun",
  "Broad Sword": "Iron Sword",
  "Broadsword": "Iron Sword",
  "Bronze Armour": "Bronze Armor",
  "Bronze Helm": "Bronze Helmet",
  "C Bag": "Cute Bag",
  "Carabineer Mail": "Carabini Mail",
  "Catskin Bag": "Cute Bag",
  "Celebrant Miter": "Holy Miter",
  "Celebrant's Miter": "Holy Miter",
  "Celebrants Miter": "Holy Miter",
  "Chain Vest": "Chain Shirt",
  "Chainmail": "Chain Mail",
  "Close Helmet": "Cross Helmet",
  "Clothing": "Clothes",
  "Clothings": "Clothes",
  "Costume": "Clothes",
  "Costumes": "Clothes",
  "Crimson Vest": "Mystic Vest",
  "Croakadile Bag": "Cute Bag",
  "Crocodile Bag": "Cute Bag",
  "Cross Bow": "Arbalest",
  "Cross Helm": "Cross Helmet",
  "Crystal Helm": "Crystal Helmet",
  "Cypress Rod": "Cypress Pole",
  "Damask Cloth": "Persia",
  "Defence Ring": "Defense Ring",
  "Defense Armlet": "Iron Armlet",
  "Diamond Armour": "Diamond Armor",
  "Diamond Bracelet": "Diamond Armlet",
  "Diamond Helm": "Diamond Helmet",
  "Eight Fluted Pole": "Octagon Rod",
  "Eight-fluted Pole": "Octagon Rod",
  "Elven Cloak": "Elf Mantle",
  "Escutcheon 2": "Hero Shield",
  "Escutcheon II": "Hero Shield",
  "FS Bag": "Star Bag",
  "Faerie Harp": "Fairy Harp",
  "Fairie Harp": "Fairy Harp",
  "Fallingstar Bag": "Star Bag",
  "Feather Cap": "Feather Hat",
  "Featherweave Cloak": "Feather Mantle",
  "Flame Mace": "Flame Whip",
  "Flare Gun": "Blaze Gun",
  "Gaia Gear": "Earth Clothes",
  "Gastrafitis": "Gastrophetes",
  "Genji Armour": "Genji Armor",
  "Genji Glove": "Genji Gauntlet",
  "Genji Helm": "Genji Helmet",
  "Giant's Axe": "Giant Axe",
  "Giants Axe": "Giant Axe",
  "Glacial Gun": "Blaze Gun",
  "Gladius": "Short Blade",
  "Goku Pole": "Gokuu Pole",
  "Goku Rod": "Gokuu Pole",
  "Gokuu Rod": "Gokuu Pole",
  "Gokuu's Pole": "Gokuu Pole",
  "Gold Armour": "Gold Armor",
  "Gold Hairpin": "Golden Hairpin",
  "Gold Helm": "Gold Helmet",
  "Golden Armor": "Gold Armor",
  "Golden Armour": "Gold Armor",
  "Golden Helm": "Gold Helmet",
  "Golden Helmet": "Gold Helmet",
  "Golden Shield": "Gold Shield",
  "Golden Staff": "Gold Staff",
  "Grand Helm": "Grand Helmet",
  "Guardian Armlet": "Iron Armlet",
  "Guardian Bracelet": "Iron Armlet",
  "H Bag": "Hydra Bag",
  "Hairband": "Cachusha",
  "Headband": "Twist Headband",
  "Heavens Cloud": "Heaven's Cloud",
  "Hempen Robe": "Linen Robe",
  "Hermes Shoes": "Sprint Shoes",
  "Hero's Shield": "Hero Shield",
  "Hidden Knife": "Blind Knife",
  "Hydrascale Bag": "Hydra Bag",
  "Ice Bow": "Silver Bow",
  "Icebrand": "Ice Brand",
  "Iga Blade": "Iga Knife",
  "Invisibility Cloak": "Vanish Mantle",
  "Iron Flail": "Flail",
  "Iron Helm": "Iron Helmet",
  "Ivory Pole": "Ivory Cane",
  "Ivory Rod": "Ivory Cane",
  "Japa Mala": "108 Gems",
  "Javelin 2": "Gungnir",
  "Javelin II": "Gungnir",
  "Jujitsu Gi": "Judo Outfit",
  "Kaiser Shield": "Kaiser Plate",
  "Kiku-ichimonji": "Kikuichimonji",
  "Kikuichimoji": "Kikuichimonji",
  "Knightslayer": "Night Killer",
  "Kodachi": "Short Blade",
  "Koga Blade": "Koga Knife",
  "Kotetsu": "Koutetsu Knife",
  "Lambent Hat": "Flash Hat",
  "Lamia's Harp": "Lamia Harp",
  "Lamias Harp": "Lamia Harp",
  "Leather Armour": "Leather Armor",
  "Leather Cloak": "Leather Mantle",
  "Leather Clothing": "Leather Outfit",
  "Leather Hat": "Leather Cap",
  "Leather Helm": "Leather Helmet",
  "Leather Plate": "Mystic Vest",
  "Leather Vest": "Mystic Vest",
  "Light Armor": "Clothes",
  "Light Armors": "Clothes",
  "Light Armour": "Clothes",
  "Light Armours": "Clothes",
  "Long Sword": "Iron Sword",
  "Longbow": "Long Bow",
  "Longsword": "Iron Sword",
  "Lordly Robe": "Robe of Lords",
  "Luminous Robe": "Light Robe",
  "Mage Cloak": "Wizard Mantle",
  "Mage Staff": "Power Staff",
  "Mage's Cloak": "Wizard Mantle",
  "Mage's Staff": "Power Staff",
  "Magepower Glove": "Magic Gauntlet",
  "Mages Cloak": "Wizard Mantle",
  "Mages Staff": "Power Staff",
  "Magick Ring": "Magic Ring",
  "Mirror Mail": "Reflect Mail",
  "Monster Dict": "Bestiary",
  "Musk Pole": "Musk Stick",
  "Musk Rod": "Musk Stick",
  "Mythril Armour": "Mythril Armor",
  "Mythril Helm": "Mythril Helmet",
  "Mythril Vest": "Mirage Vest",
  "N Kai Armlet": "N-Kai Armlet",
  "Nagnarok": "Nagrarock",
  "Nerf Gun": "Romanda Gun",
  "Ninja Gear": "Secret Clothes",
  "Ninja Knife": "Kunai",
  "Ninja Longblade": "Ninja Edge",
  "Nu Khai Armband": "N-Kai Armlet",
  "Nu-Khai Armband": "N-Kai Armlet",
  "Oberisk": "Obelisk",
  "Omnilex": "Madlemgen",
  "Orichalcum Dirk": "Orichalcum",
  "Osafune": "Bizen Boat",
  "Outfit": "Clothes",
  "Outfits": "Clothes",
  "P Bag": "Panther Bag",
  "Pantherskin Bag": "Panther Bag",
  "Papyrus Plate": "Papyrus Codex",
  "Pea Shooter": "Romanda Gun",
  "Platina Armor": "Platinum Armor",
  "Platina Armour": "Platinum Armor",
  "Platina Dagger": "Cultist Dagger",
  "Platina Helmet": "Platinum Helmet",
  "Platina Shield": "Platinum Shield",
  "Platinum Armour": "Platinum Armor",
  "Platinum Dagger": "Cultist Dagger",
  "Platinum Helm": "Platinum Helmet",
  "Plumed Hat": "Feather Hat",
  "Poison Bow": "Venom Bow",
  "Power Garb": "Power Sleeve",
  "Power Gauntlet": "Power Wrist",
  "Protect Ring": "Defense Ring",
  "Proudhide Bag": "Panther Bag",
  "Ramia Harp": "Lamia Harp",
  "Red Vest": "Mystic Vest",
  "Ringmail": "Chain Shirt",
  "Rod of Faith": "Faith Rod",
  "Romandan Pistol": "Romanda Gun",
  "Rubber Boots": "Rubber Shoes",
  "Rubber Suit": "Rubber Costume",
  "Rune Sword": "Rune Blade",
  "Runeblade": "Rune Blade",
  "Sasuke Blade": "Sasuke Knife",
  "Sasuke's Blade": "Sasuke Knife",
  "Sasukes Blade": "Sasuke Knife",
  "Scholar Robe": "Scholar Outfit",
  "Septieme": "Setiemson",
  "Serpent Staff": "Rainbow Staff",
  "Shirt": "Clothes",
  "Shirts": "Clothes",
  "Short Edge": "Short Blade",
  "Shoulder Cape": "Small Mantle",
  "Silken Robe": "Silk Robe",
  "Silver Vest": "Mirage Vest",
  "Sleep Blade": "Sleep Sword",
  "Snipe Bow": "Arbalest",
  "Sortilege": "Salty Rage",
  "Spellbinder": "Spell Edge",
  "Spiked Boots": "Spike Shoes",
  "Staff of the Magi": "Sage Staff",
  "Stoneshooter": "Stone Gun",
  "Thief Hat": "Thief Cap",
  "Thief's Cap": "Thief Cap",
  "Thief's Hat": "Thief Cap",
  "Thief's Knife": "Thief Knife",
  "Thiefs Cap": "Thief Cap",
  "Thiefs Hat": "Thief Cap",
  "Thiefs Knife": "Thief Knife",
  "Twisted Headband": "Twist Headband",
  "Vampire Cape": "Dracula Mantle",
  "Vest": "Clothes",
  "Vests": "Clothes",
  "Winged Boots": "Feather Boots",
  "Wizard Clothing": "Scholar Outfit",
  "Wizard Hat": "Triangle Hat",
  "Wizard Outfit": "Scholar Outfit",
  "Wizard Staff": "Power Staff",
  "Wizard's Hat": "Triangle Hat",
  "Wizard's Robe": "Wizard Robe",
  "Wizard's Rod": "Wizard Rod",
  "Wizards Hat": "Triangle Hat",
  "Wizards Robe": "Wizard Robe",
  "Wizards Rod": "Wizard Rod",
  "Wyrmweave Silk": "Ryozan Silk",
  "Zeus Mace": "Mace of Zeus",
  "Zwill Straightblade": "Zorlin Shape"
};
